import { Component, Input } from '@angular/core';

@Component({
  selector: 'lib-container-list-item-dummy',
  templateUrl: './container-list-item-dummy.component.html',
  styleUrls: ['./container-list-item-dummy.component.scss']
})
export class ContainerListItemDummyComponent {
  @Input() public gridColumnsWidths = 'auto';
}
